import { CanDeactivateFn } from "@angular/router";
import type { QuestionDetail } from "./question-detail";

/**
 * Blocks navigating away from the Checklist Detail form (Question Detail) when the current
 * question has an answer but its required Notes/Photo are missing — mirrors the confirmation
 * shown by the in-app Back button, but also covers exits that don't go through that button:
 * the browser back/forward buttons, the Android hardware back button, and the iOS back swipe
 * gesture all navigate via the same history/popstate mechanism that Angular Router guards
 * intercept, so routing this check through `CanDeactivate` makes all of them consistent.
 */
export const questionDetailCanDeactivateGuard: CanDeactivateFn<QuestionDetail> = component => component.canDeactivate();
